'use strict';
const env = require('../../environments/environment').environment;
angular.module('gestiondecriseApp').config(function () {
  Parse.initialize(env.parseAppId, env.parseJSKey);
  Parse.serverURL = env.parseServerUrl;
});
